<ngx-ui-loader [loaderId]="'loader-77'"></ngx-ui-loader>
<kendo-window *ngIf="showtaxinfo" draggable="true" (close)="windowClose()" [title]="headtitlePopup">
  <div class="inner-wrapper" *ngFor="let t of taxList">
    <a (click)="FilterAddAccountScreen(t.taxID, t.lastName)" routerLinkActive="router-link-active"><strong>First
        Name:</strong> &nbsp;{{ t.firstName }}&nbsp;&nbsp;
      <strong>Last Name:</strong> &nbsp;{{ t.lastName }}</a>
  </div>
</kendo-window>
<div kendoWindowContainer></div>
<div kendoDialogContainer></div>
<form [formGroup]="profileForm" (ngSubmit)="onSubmit(buttonType)" class="was-validated">
  <table Id="AccountTable">
    <tbody>
      <tr width="550px">
        <td width="42%" valign="top">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Client and Account Information</h3>
            </div>
            <div class="card-body space-y-2 text-sm" style="line-height: 1.2;">
              <label class="tiny text-black dark:text-white" *ngIf="Rolerep"> Rep: </label>&nbsp;&nbsp;
              <span class="tiny text-black dark:text-white" *ngIf="Rolerep">{{ labelClient }}</span>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> Rep Code: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white">{{ labelRepCode }}</span>
              </div>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> Client Name: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white">{{ labelClientName }}</span>
              </div>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> Client DOB: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white"> {{ labelDOB | date : 'MM/dd/yyyy' }}</span>
                <span class="tiny text-black dark:text-white" *ngIf="calculatedDob">
                  - {{ calculatedDob }} yo
                </span>
              </div>
              <div class="spacing" *ngIf="labelSplitRepNameonoff">
                <label class="tiny text-black dark:text-white"> Split Rep Name: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white">{{ labelSplitRepName }}</span>
              </div>
<!--               <div class="spacing">
                <label class="tiny text-black dark:text-white"> Product Type: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white">{{ labelProductType }}</span>
              </div> -->
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> Transaction Type: </label>&nbsp;&nbsp;
                <span class="tiny text-black dark:text-white">{{ labelTransaction }}</span>
              </div>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> Account Name: </label>
                <!-- [data]="SeletedList"-->
                <kendo-dropdownlist formControlName="AccountName" style="width: 250px; margin-left: 10px">
                </kendo-dropdownlist>
              </div>
              <div class="spacing" *ngIf="RoleAdvisor">
                <label class="tiny"><i class="fas fa-asterisk" [ngClass]="{
                      novalue: profileForm.get('ClientTypeId')?.value !== 5 && !profileForm.get('EmailAddress')?.value,
                      havevalue: profileForm.get('ClientTypeId')?.value === 5 || profileForm.get('EmailAddress')?.value
                    }"></i>&nbsp; Email: </label>&nbsp;&nbsp;<input kendoTextBox type="email"
                  formControlName="EmailAddress" [required]="profileForm.get('ClientTypeId')?.value !== 5" />
              </div>
              <div class="spacing" *ngIf="RoleAdvisor">
                <label class="tiny"> Mobile/Phone: </label>&nbsp;&nbsp;<kendo-maskedtextbox [mask]="mobileMask"
                  formControlName="Mobile" [promptPlaceholder]="' '"></kendo-maskedtextbox>
              </div>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> &nbsp; Date Received: </label>&nbsp;<kendo-datepicker #dp2
                  style="width: 200px; height: 25px" (focus)="onFocus12(dp2)" [focusedDate]="focusedDateAccountform"
                  formControlName="DateReceivedForm" class="form-control">
                </kendo-datepicker>
              </div>
              <div class="spacing">
                <label class="tiny text-black dark:text-white"> &nbsp; Date of Account Form: </label>&nbsp;<kendo-datepicker #dp1
                  style="width: 200px; height: 25px" (focus)="onFocus1(dp1)" (blur)="onDateFormBlur()" [focusedDate]="focusedDateAccountform"
                  formControlName="DateOfNewAccountForm" class="form-control"
                  [disabledDates]="accountDateDisabledDates">
                </kendo-datepicker>
                <span class="tiny text-black dark:text-white" *ngIf="ageAtTransaction">
                  - {{ ageAtTransaction }} yo
                </span>
              </div>
              <div class="spacing">
                <label class="tiny"> Copy of DL: </label>&nbsp;&nbsp;<kendo-dropdownlist formControlName="CopyOfDl"
                  [data]="SeletedStatus" style="width: 250px">
                </kendo-dropdownlist>
              </div>
             <!--  <div class="spacing">
                <label class="tiny"> Mail Log: </label>&nbsp;&nbsp;<kendo-dropdownlist formControlName="MailLog"
                  [data]="SeletedMailToList" style="width: 250px">
                </kendo-dropdownlist>
              </div>
              <div class="spacing">
                <label class="tiny"> &nbsp;Mail To: </label>&nbsp;&nbsp;<input kendoTextBox type="text" #first
                  style="width: 250px" formControlName="MailTo" class="2form-control" />
              </div>
              <div class="spacing">
                <--   [focusedDate]="MailDate"--
                <label class="tiny"> &nbsp; Mail Date: </label>&nbsp;<kendo-datepicker #dp14
                  style="width: 200px; height: 25px; margin-left: 5px" formControlName="MailDate" class="form-control">
                </kendo-datepicker>
              </div>
              <div class="spacing">
                <label class="tiny"> &nbsp;Document Description: </label>&nbsp;&nbsp;<input kendoTextBox type="text"
                  #first style="width: 250px" formControlName="DocumentDescription" class="2form-control" />
              </div> -->
              <div class="spacing radiobx">
                <label class="tiny" style="width: 18%"> &nbsp; Alert Rep </label>&nbsp;
                <label style="margin-left: 40px"><span class="tiny">Yes:&nbsp;</span>
                  <input type="radio" required name="AlertRep" required value="true" formControlName="AlertRep"
                    kendoRadioButton style="width: 1.5em" (change)="showAlertRepText()" />
                </label>
                <label for="radio-two"><span class="tiny">No:&nbsp; </span>
                  <input id="radio-two" type="radio" required name="AlertRep" required value="false"
                    formControlName="AlertRep" kendoRadioButton style="width: 1.5em"
                    (change)="clearAlertRepText()" /></label>
              </div>
              <div class="spacing">
                <label class="tiny">
                  &nbsp;CC Emails (separate by comma): </label>&nbsp;&nbsp;<input kendoTextBox style="width: 245px"
                  type="text" #ccemail formControlName="ccemails" class="1form-control" />
              </div>
              <!-- <div class="spacing">
                <label class="tiny"> Alert Rep Text: </label
                >&nbsp;&nbsp;<kendo-dropdownlist
                  formControlName="AlertRepTextselect"
                  [data]="SeletedList"
                  style="width: 350px"
                >
                </kendo-dropdownlist>
              <!-- </div> -->
              <div class="spacing">
                <label class="tiny">Alert Rep Text: </label>&nbsp;&nbsp;
                <textarea kendoTextArea formControlName="AlertRepText" [rows]="7"  resizable="vertical" style="width: 350px;"></textarea>
                <!--         <kendo-textarea
                  rows="5"
                  cols="100"
                  style="width: auto !important"
                  resizable="both"
                  formControlName="AlertRepText"
                >
                </kendo-textarea> -->
              </div>
              <div class="spacing">
                <label class="tiny"> Address: </label>&nbsp;&nbsp;
                <div class="surroundingdiv">
                  <div>
                    Address1 :
                    <input class="gwidth" kendoTextBox id="address1" formControlName="Address1" name="address1" />
                  </div>
                  <div class="gpadd">
                    Address2 :
                    <input class="gwidth" kendoTextBox id="Address2" formControlName="Address2" name="Address2" />
                  </div>
                  <div class="gpadd">
                    City :
                    <input class="gwidth" kendoTextBox id="City" formControlName="City" name="City" />
                  </div>
                  <div class="gpadd">
                    State :
                    <kendo-dropdownlist #state name="State" formControlName="State" [data]="listStates"
                      [valuePrimitive]="true" [textField]="'stateValue'" [valueField]="'stateValue'"
                      style="width: 100px">
                    </kendo-dropdownlist>
                  </div>
                  <div class="gpadd">
                    Zip Code :
                    <input class="gwidth" kendoTextBox id="ZipCode" formControlName="ZipCode" name="ZipCode" />
                  </div>
                  <div class="gtext" *ngIf="getBlotterId < 1">
                    * Please verify Address before making changes.
                  </div>
                </div>
                <!--<div class="gcheck" *ngIf="getBlotterId < 1">
                  <input type="checkbox" kendoCheckBox id="addressvalidated"  name="addressvalidated"
                    formControlName="addressvalidated" />
                  Address Validated <span style="color: red">*</span>
                </div>-->
              </div>
              <div class="spacing radiobx">
                <label class="tiny" style="width: 18%">
                  &nbsp; Waive Fee? </label>&nbsp;
                <label style="margin-left: 40px"><span class="tiny">Yes:&nbsp;</span>
                  <input type="radio" required name="WaveFee" required value="true" formControlName="WaveFee"
                    kendoRadioButton style="width: 1.5em" />
                </label>
                <label for="radio-two"><span class="tiny">No:&nbsp; </span>
                  <input id="radio-two" type="radio" required name="WaveFee" required value="false"
                    formControlName="WaveFee" kendoRadioButton style="width: 1.5em" /></label>
              </div>
              <div class="spacing status-history-container">
                <label class="tiny"> Status: </label>
                <span class="tiny" style="margin-right: 5px">{{
                  labelStatus
                  }}</span>
                <!-- Same button and rule as the Transaction page: shown for any saved transaction -->
                <button *ngIf="getBlotterId > 0" type="button"
                  (click)="openStatusHistory(getBlotterId)"
                  class="px-3 py-1.5 text-sm font-medium text-blue-600 dark:text-blue-400
                         border border-blue-600 dark:border-blue-400
                         rounded-md hover:bg-blue-50 dark:hover:bg-blue-900
                         focus:outline-none focus:ring-2 focus:ring-blue-300
                         transition-colors duration-200">
                  View Status History
                </button>
              </div>
              <!-- Same rules as the Transaction page; values come from the backend via the form -->
              <div class="spacing" *ngIf="getBlotterId > 0">
                <label class="tiny"> Last Modified By: </label>&nbsp;&nbsp;
                <span class="tiny">{{ profileForm.get('ModifiedBy')?.value }}</span>
              </div>
              <div class="spacing" *ngIf="getBlotterId > 0">
                <label class="tiny"> Last Modified Date: </label>&nbsp;&nbsp;
                <span class="tiny">{{ profileForm.get('ModifiedDate')?.value | date : 'MM/dd/yyyy' }}</span>
              </div>
              <!--  <AP> Remove for now keep just in case they want it back 8/6/2024
              <div class="spacing">
                <label class="tiny"> Update Status: </label>&nbsp;&nbsp;
                <kendo-dropdownlist
                  formControlName="StatusTypeID"
                  [data]="SeletedupdatedList"
                  textField="text"
                  valueField="value"
                  [valuePrimitive]="true"
                  style="width: 350px"
                >
                </kendo-dropdownlist>
              </div> -->
            </div>
          </div>
        </td>
        <td width="890px" valign="top">
          <div class="card ml-2">
            <div class="card-header">
              <h3 class="card-title">Investment Information</h3>
            </div>
            <div class="card-body space-y-3 text-sm">
              <div class="Accountwrapper">
                <label class="tiny">
                  <ng-icon name="heroCurrencyDollar" [ngClass]="{
                      novalue: annualbool === true,
                      havevalue: annualboolvalue === true
                    }"></ng-icon>
                  &nbsp;Annual Income From: </label>&nbsp;&nbsp;
                <kendo-numerictextbox #annualIncFrom [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
                  formControlName="AnnualIncFrom" AllowRounding="True" required [autoCorrect]="autoCorrect">
                </kendo-numerictextbox><span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
                <kendo-numerictextbox [format]="'0'" [min]="0" [spinners]="false" formControlName="AnnualIncTo" required
                  (ngModelChange)="checkvalueGreater($event, 0)">
                </kendo-numerictextbox><span class="msg" *ngIf="showmessage0">
                  To must be Greater than From</span>
                <div class="spacing">
                  <label class="tiny">
                    <ng-icon name="heroCurrencyDollar" [ngClass]="{
                        novalue: networthbool === true,
                        havevalue: networthboolvalue === true
                      }"></ng-icon>
                    &nbsp;Net Worth From: </label>&nbsp;&nbsp;
                  <kendo-numerictextbox [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
                    formControlName="NetWorthFrom" AllowRounding="True" required [autoCorrect]="autoCorrect">
                  </kendo-numerictextbox><span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
                  <kendo-numerictextbox (ngModelChange)="checkvalueGreater($event, 1)" [format]="'0'" [value]="numValue"
                    [min]="0" [spinners]="false" formControlName="NetWorthTo" required AllowRounding="True"
                    [autoCorrect]="autoCorrect">
                  </kendo-numerictextbox><span *ngIf="showmessage1" class="msg">
                    To must be Greater than From</span>
                </div>
                <div class="spacing">
                  <label class="tiny">
                    <ng-icon name="heroCurrencyDollar" [ngClass]="{
                        novalue: Liquidbool === true,
                        havevalue: Liquidboolvalue === true
                      }"></ng-icon>&nbsp;Liquid Net Worth From: </label>&nbsp;&nbsp;
                  <kendo-numerictextbox [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
                    formControlName="LiquidNWFrom" AllowRounding="True" required [autoCorrect]="autoCorrect">
                  </kendo-numerictextbox><span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
                  <kendo-numerictextbox [value]="numValue" [format]="'0'" [min]="0" [spinners]="false"
                    formControlName="LiquidNWTo" AllowRounding="False" (ngModelChange)="checkvalueGreater($event, 2)"
                    [autoCorrect]="autoCorrect" required>
                  </kendo-numerictextbox><span class="msg" *ngIf="showmessage2">
                    To must be Greater than From</span>
                </div>
                <div class="spacing">
                  <label class="tiny">
                    <ng-icon name="heroExclamationCircle" [ngClass]="{
                        novalue: riskbool === true,
                        havevalue: riskvalue === true
                      }"></ng-icon>&nbsp;Risk Exposure: </label>&nbsp;
                  <kendo-dropdownlist #drop formControlName="InvestmentProfileId" [textField]="'profileDescription'"
                    [valueField]="'investmentProfileId'" [valuePrimitive]="true" required [virtual]="virtual"
                    [loading]="investloading" [data]="InvestObjLists" style="width: 350px">
                  </kendo-dropdownlist>
                </div>
                <div class="spacing">
                  <label class="tiny">
                    <ng-icon name="heroExclamationCircle" [ngClass]="{
                        novalue: investbool === true,
                        havevalue: investvalue === true
                      }"></ng-icon>&nbsp;Investment Objective: </label>&nbsp;&nbsp;<kendo-dropdownlist #drop
                    formControlName="InvObjectiveId" [textField]="'description'" [valuePrimitive]="true" required
                    [valueField]="'invesmentObjectiveId'" [virtual]="virtual" [loading]="investobjloading" required
                    [data]="InvestObjnwewLists" style="width: 350px">
                  </kendo-dropdownlist>
                </div>
                <div class="spacing">
                  <label class="tiny">
                    <ng-icon name="heroExclamationCircle" [ngClass]="{
                        novalue: liquiddropbool === true,
                        havevalue: liquiddropvalue === true
                      }"></ng-icon>&nbsp;Liquidity Needs: </label>&nbsp;&nbsp;<kendo-dropdownlist #drop
                    formControlName="LiquidityNeedsId" [textField]="'description'" [valuePrimitive]="true" required
                    [valueField]="'liquidityNeedsId'" [virtual]="virtual" [loading]="liqquidloading"
                    [data]="LiquidityNeedsLists" style="width: 350px">
                  </kendo-dropdownlist>
                </div>
                <div class="spacing">
                  <!--                   {{TimeHorizonLists | json}} -->
                  <label class="tiny">
                    <ng-icon name="heroExclamationCircle" [ngClass]="{
                        novalue: timehorizonbool === true,
                        havevalue: timehorizonboolvalue === true
                      }"></ng-icon>&nbsp;Time Horizon: </label>&nbsp;&nbsp;<kendo-dropdownlist
                    formControlName="InvestmentTimeHorizonId" [textField]="'lengthOfTime'" [valuePrimitive]="true"
                    required [valueField]="'invesmentTimeHorizonId'" [virtual]="virtual" [loading]="timezoneloading"
                    [data]="TimeHorizonLists" style="width: 350px">
                  </kendo-dropdownlist>
                </div>
                <div class="spacing">
                  <kendo-label class="tiny" [for]="'name'" [text]="name">
                  </kendo-label>
                </div>
              </div>
            </div>
          </div>
          <div class="card ml-2 mt-4" style="width: 850px">
            <div class="card-header">
              <h3 class="card-title">Investment Experience (since year)</h3>
            </div>
            <div class="card-body space-y-3 text-sm">
              <div class="Accountwrapper">
                <div class="investment-experience-grid">
                  <div class="exp-row">
                    <div class="exp-label">Equities:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="EquitiesExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Options:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="OptionsExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>

                  <div class="exp-row">
                    <div class="exp-label">Fixed Income:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="FixedIncExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Mutual funds:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="MutFundsExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  
                  <div class="exp-row">
                    <div class="exp-label">Unit Investment Trust:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="Uitexp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Exchange Trade Fund:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="Etfexp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  
                  <div class="exp-row">
                    <div class="exp-label">Real Estate:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="RealEstateExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Insurance:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [spinners]="false" [format]="'0'"
                        formControlName="InsExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  
                  <div class="exp-row">
                    <div class="exp-label">Variable Annuities:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="Vaexp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Fixed Annuities:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="FixedAnnExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  
                  <div class="exp-row">
                    <div class="exp-label">Precious Metals:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="PrecMetExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Commodities, Future:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="CommExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  
                  <div class="exp-row">
                    <div class="exp-label">Other:</div>
                    <div class="exp-year-label">Year:</div>
                    <div class="exp-input">
                      <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
                        formControlName="OtherExp" [min]="investmin" [max]="investmax" [value]="numValue" style="width: 180px;">
                      </kendo-numerictextbox>
                    </div>
                    <div class="exp-label">Desc:</div>
                    <div class="exp-input exp-desc-input" style="grid-column: span 2;">
                      <input kendoTextBox type="text" formControlName="OtherExpDesc" style="width: 100%;" />
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          <div class="card ml-2 mt-4">
            <div class="card-header">
              <h3 class="card-title"><ng-icon name="heroChatBubbleLeftRight" style="color: green; font-size: 20px"></ng-icon>&nbsp;Add a Comment</h3>
            </div>
            <div class="card-body space-y-3 text-sm">
              <label class="tiny"> </label>&nbsp;<textarea kendoTextArea formControlName="Comment"  resizable="vertical" [rows]="15" style="width: 100%; min-height: 200px;"></textarea>
              <input type="text" formControlName="ClientNoteId" *ngIf="false" />
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="card mt-4 floating-action-container">
    <div class="card-body">
      <div class="floating-action-col">
      <label [for]="statusDropdown" class="floating-action-label">
        Update Status:
      </label>
      <kendo-dropdownlist #statusDropdown formControlName="StatusTypeID" [data]="SeletedupdatedList" textField="text"
        valueField="value" [valuePrimitive]="true" style="width: 350px; height: 36px">
      </kendo-dropdownlist>
    </div>
    <div class="floating-action-col-right">
      <label class="floating-action-label" *ngIf="getBlotterId > 0">
        Transaction ID: {{ getBlotterId }}
      </label>
      <label class="floating-action-label">
        <!-- Last Modified: {{ lastModifiedBy }}&nbsp;&nbsp;{{ lastModifiedDate | date : 'MM/dd/yyyy h:mm:ss a' }}
      --> </label> 
      <label class="floating-action-label" *ngIf="getBlotterId < 1" style="padding-top: 10px">
      </label>
      <div class="floating-action-row">
        <button kendoButton *ngIf="!queryupdate" [disabled]="
            !profileForm.valid ||
            submitdisable ||
            showmessage0 === true ||
            showmessage1 === true ||
            showmessage2 === true
          ">
          Submit
        </button>
        <button kendoButton [disabled]="!profileForm.valid || isUpdateDisabled" (click)="onSubmit('Next')" *ngIf="queryupdate">
          Update
        </button>
        <button kendoButton *ngIf="Rolerep" (click)="onSubmit('Removious')">
          Delete
        </button>
      </div>
    </div>
  </div>
  <!--   {{editaccountlist | json}} -->

<!-- Dialogs and windows outside the form -->
<kendo-dialog title="Please confirm" *ngIf="opened" (close)="close('cancel')" [minWidth]="250" [width]="450">
  <p style="margin: 30px; text-align: center">
    Are you sure you want delete this transaction?
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="close('no')">No</button>
    <button kendoButton (click)="continue()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- 
<kendo-dialog animate="animates" (close)="closeDialog()" *ngIf="showStatusHistoryDialog" width="900px">
  <kendo-dialog-titlebar>
    <div><span class="k-icon k-i-print"></span> View Status History</div>
  </kendo-dialog-titlebar>
-->

  <!-- Dark backdrop overlay -->
  <div *ngIf="showStatusHistoryDialog" 
       style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.7); z-index: 10000;"
       (click)="closeDialog()">
  </div>

  <kendo-window
  *ngIf="showStatusHistoryDialog"
  [width]="850"
  [resizable]="true"
  [draggable]="true"
  (close)="closeDialog()"
  [style.position]="'fixed'"
  [style.top]="'50%'"
  [style.left]="'50%'"
  [style.transform]="'translate(-50%, -50%)'"
  [style.z-index]="'10001'"
>
  <!-- Matches the Transaction page's status history window -->
  <ng-template kendoWindowTitleBar>
    <div class="flex items-center gap-2">
      <span class="k-icon k-i-print"></span>
      <span>View Status History</span>
    </div>
  </ng-template>

  <kendo-grid
    [data]="stathistorylist"
    style="font-size: 10px"
    [loading]="!stathistorylist"
  >
    <kendo-grid-column [width]="50">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="statusTypeDesc" title="StatusType Description" [width]="170">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span style="font-size:10px">{{ dataItem.statusTypeDesc }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="modifiedBy" title="Modified by" [width]="150"></kendo-grid-column>

    <kendo-grid-column field="modifiedDate" title="Modified Date" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span style="font-size:10px">
          {{ dataItem.modifiedDate | date : 'MM/dd/yyyy  h:mm:ss a' }}
        </span>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div class="mt-4 text-center">
    <button kendoButton (click)="closeDialog()" style="width: 100%">
      Close Window
    </button>
  </div>
</kendo-window>
